// Close the compact drawer when desktop navigation replaces it. This releases
// Dawn's focus trap and body scroll lock, including the 990–1199px tablet range.
if (!window.miniMintHeaderResizeBound) {
  window.miniMintHeaderResizeBound = true;
  window.matchMedia('(min-width: 1200px)').addEventListener('change', (event) => {
    if (!event.matches) return;
    document.querySelectorAll('.mini-mint-header header-drawer').forEach((drawer) => {
      const summary = drawer.querySelector('summary');
      if (drawer.querySelector('details[open]') && typeof drawer.closeMenuDrawer === 'function') {
        drawer.closeMenuDrawer(new Event('resize'), summary);
        summary.setAttribute('aria-expanded', 'false');
        drawer.closest('header').querySelector('.header__heading-link')?.focus();
      }
    });
  });
}
